import { render, staticRenderFns } from "./ActiveGameModule.vue?vue&type=template&id=002e059b&"
import script from "./ActiveGameModule.vue?vue&type=script&lang=js&"
export * from "./ActiveGameModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports